export const faqs = [
  {
    question: '什么是膀胱过度活动症？',
    answer: '膀胱过度活动症（OAB）是一种以尿急为核心症状的综合征，通常伴有尿频和夜尿增多，可伴有或不伴有急迫性尿失禁。其根本原因在于膀胱逼尿肌在不该收缩的时候出现不自主收缩。OAB并非衰老的必然结果，通过行为治疗、盆底肌训练和必要的药物治疗，大多数患者可以获得显著改善。',
  },
  {
    question: '盆底肌训练需要多久才能看到效果？',
    answer: '盆底肌训练是一个需要耐心和坚持的过程。大多数人在坚持规范训练4-6周后开始感受到初步改善（如漏尿次数减少），更显著的效果通常需要坚持训练3-6个月。关键在于：找到正确的肌肉、保持规律的训练频率（每天3组）、逐渐增加训练强度，并长期保持。',
  },
  {
    question: '每天应该喝多少水才对膀胱最健康？',
    answer: '一般成年人建议每日饮水1.5-2升（约6-8杯），但具体需求因人而异。关键在于饮水方式：分散在一天中均匀饮用，避免一次性大量饮水；睡前2小时减少饮水；选择白开水作为主要饮品。一个简单的自检方法是观察尿液颜色——淡稻草色或浅黄色通常表明水分充足。',
  },
  {
    question: '憋尿对身体有哪些危害？',
    answer: '长期或频繁憋尿可能带来多种健康风险：增加尿路感染的概率（细菌在膀胱内繁殖时间延长）；可能导致膀胱肌肉过度拉伸，影响膀胱的正常收缩功能；严重时可导致尿液反流至输尿管和肾脏，造成肾损伤；还可能增加膀胱结石形成的风险。建议每2-4小时排尿一次，不应长期忍耐尿意。',
  },
  {
    question: '咖啡因真的会影响膀胱吗？',
    answer: '是的，咖啡因对膀胱有明确的影响。它一方面作为利尿剂增加尿液生成，另一方面直接刺激膀胱逼尿肌，可能诱发或加重尿频和尿急症状。对于膀胱敏感的人群，即使少量咖啡因也可能产生明显影响。如果你有膀胱不适症状，建议尝试暂停咖啡因摄入2周，观察症状是否改善。',
  },
  {
    question: '男性也会得压力性尿失禁吗？',
    answer: '会的。虽然压力性尿失禁在女性中更为常见（尤其是产后和更年期女性），但男性也可能发生，最常见于前列腺癌根治术后的患者。手术可能损伤尿道括约肌或其神经支配，导致控尿能力下降。男性同样可以通过盆底肌训练获益，术前开始训练的患者术后尿控恢复往往更快。',
  },
  {
    question: '膀胱训练和憋尿有什么区别？',
    answer: '两者有本质区别。膀胱训练（如定时排尿法）是有计划的、科学的循序渐进过程——按照预定的时间表主动排尿，逐步延长排尿间隔，目标是恢复膀胱的正常容量和功能。而憋尿是无计划地、被动地忍耐尿意直到无法忍受，这种行为可能带来健康风险。正确的膀胱训练不会让你感到疼痛或极度不适。',
  },
  {
    question: '尿路感染和膀胱健康有什么关系？',
    answer: '尿路感染（UTI）是膀胱健康的重要威胁。反复的尿路感染可能导致膀胱黏膜受损，使膀胱变得更加敏感，从而出现尿频、尿急等症状。预防尿路感染的措施包括：保持充足饮水以稀释尿液和冲刷细菌、排尿和性生活后注意清洁、避免长时间憋尿、选择棉质透气内裤等。如果一年内发生3次以上尿路感染，建议就医评估。',
  },
];